import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const PhotoSectionWrapper = styled.div``

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Title = styled(TypeStyle.HeadlineExtraSmall)`
  display: block;
  font-size: ${o => o.theme.typography.font.size[18]};
  color: ${o => o.theme.color.deprecated.obsidian};
`

export const PaginationWrapper = styled.div`
  display: none;

  ${fromMd} {
    display: block;
  }
`

export const PaginationButton = styled.button<{ disabled: boolean }>`
  width: ${o => o.theme.spacing(6)};
  height: ${o => o.theme.spacing(6)};
  color: ${o =>
    o.disabled ? o.theme.color.deprecated.stone : o.theme.color.button.primary.fill.on.background};
`

export const SliderWrapper = styled.div`
  max-width: 100%;
  margin-top: ${o => o.theme.spacing(4)};
`

export const Slider = styled.div`
  outline: none;
  overflow-y: hidden;
  overflow-x: scroll;
  scroll-behavior: smooth;
  overscroll-behavior-x: contain;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  max-width: 100%;
`

export const SliderRow = styled.div`
  align-items: top;
  display: inline-flex;
  flex-wrap: nowrap;
  flex: 0;
`

export const SliderTile = styled.div<{
  tileGapDesktop: number
  tileGapMobile: number
  mobileTileWidth: number
  desktopTileWidth: number
}>`
  flex-grow: 0;
  flex-shrink: 0;
  box-sizing: border-box;

  padding-left: ${o => o.tileGapMobile / 2}px;
  padding-right: ${o => o.tileGapMobile / 2}px;

  &:first-of-type {
    margin-left: -${o => o.tileGapMobile / 2}px;
  }
  &:last-of-type {
    margin-right: -${o => o.tileGapMobile / 2}px;
  }

  width: ${o => o.mobileTileWidth}px;

  ${fromMd} {
    width: ${o => o.desktopTileWidth}px;
    padding-right: ${o => o.tileGapDesktop / 2}px;
    padding-left: ${o => o.tileGapDesktop / 2}px;
    &:first-of-type {
      margin-left: -${o => o.tileGapDesktop / 2}px;
    }
    &:last-of-type {
      margin-right: -${o => o.tileGapDesktop / 2}px;
    }
  }
`
